// extracted by mini-css-extract-plugin
export var primitiveLabel = "_u2-0";